var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.element.label?.trim()?.length)?_c('div',{staticClass:"form-textblock-element-wrapper"},[_c('p',{staticClass:"form-textblock w-100 bg-transparent m-0 p-0 d-flex align-items-end justify-content-start",style:(_vm.textStyle),attrs:{"id":`textblock-${_vm.element.id}`}},[_vm._v("\n    "+_vm._s(_vm.element.label)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }